<template>
  <sc-page-base
    :title="title"
    :loading="loadingInvoices"
    :show-back="!!title"
    @back="$router.push({ name: 'invoice-audit-list' })">
    <div v-if="invoice">
      <section
        class="level invoice-audit-detail">

        <div
          class="level-item has-text-centered box invoice-audit-detail__item"
          v-if="invoice.logistic_provider">

          <div>
            <b-tooltip
              :label="invoice.logistic_provider.name">

              <img
                :src="logisticProviderLogo"
                :alt="invoice.logistic_provider.name"
                class="invoice-audit-detail__logistic-provider" />
            </b-tooltip>

            <p
              class="heading"
              v-if="deliveryMethods.length > 0">
              Métodos de Envio: {{ deliveryMethodsNames }}
            </p>
          </div>

        </div>

        <div
          class="level-item has-text-centered box invoice-audit-detail__item"
          v-if="invoice.due_date">

          <div>
            <p class="heading">Data de vencimento</p>
            <p class="title is-5">
              {{ invoice.due_date | date }}
            </p>
          </div>

        </div>

        <div class="level-item has-text-centered box invoice-audit-detail__item">
          <div>
            <p class="heading">Divergência</p>
            <p>
              <span
                class="title is-5"
                :class="{ 'has-text-danger': invoice.divergence_value < 0 }">
                {{ invoice.divergence_value || 0 | currency }}
              </span>

              <small
                class="tag"
                :class="{
                    'is-success': invoice.divergence_percentage >= 0,
                    'is-danger': invoice.divergence_percentage < 0
                  }">
                {{ invoice.divergence_percentage || 0 | percent }}
              </small>
            </p>
          </div>
        </div>

        <div class="level-item has-text-centered invoice-audit-detail__item">
          <router-link
            class="button is-primary"
            :to="{ name: 'invoice-audit-new' }">Refazer análise de fatura</router-link>
        </div>

      </section>

      <div class="box">
        <sc-field
          label="Marcadores">
          <sc-recon-markers-input
            :tags="invoiceMarkers"
            @add="marker => linkMarker(marker.id)"
            @remove="marker => unlinkMarker(marker.id)" />
        </sc-field>
      </div>

      <div class="box">
        <sc-tabs
          v-model="activeTab">

          <sc-tab-item label="Resumo">
            <tab-invoice-audit-detail-resume />
          </sc-tab-item>

          <sc-tab-item label="Histórico">
            <tab-invoice-audit-detail-history />
          </sc-tab-item>

          <sc-tab-item label="Itens da fatura">
            <tab-invoice-audit-detail-order-items />
          </sc-tab-item>
        </sc-tabs>

        <div class="buttons is-right">

          <button
            type="button"
            class="button is-primary"
            @click="downloadInvoiceFilePerUrl(invoice.result_download_url)"
            v-if="invoice.result_download_url">Baixar arquivo de análise</button>

          <button
            type="button"
            class="button is-primary"
            @click="generateAnalyzeFile(invoice.reconciliation_invoice_id)"
            v-if="!invoice.result_download_url">Gerar arquivo de análise</button>
        </div>
      </div>
    </div>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScField,
    ScTabs,
    ScTabItem,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';
  import TabInvoiceAuditDetailResume from './components/tab-resume/TabInvoiceAuditDetailResume';
  import TabInvoiceAuditDetailHistory from './components/tab-history/TabInvoiceAuditDetailHistory';
  import TabInvoiceAuditDetailOrderItems from './components/tab-order-items/TabInvoiceAuditDetailOrderItems';
  import ScReconMarkersInput from '../../../../components/sc-recon-markers-input/ScReconMarkersInput';

  const { mapState, mapGetters, mapActions } = createNamespacedHelpers('recon/invoiceAudit');

  export default {
    name: 'page-invoice-audit-detail',
    data() {
      return {
        markers: [],
        activeTab: 0,
      };
    },
    computed: {
      ...mapState([
        'loadingInvoices',
        'invoice',
        'invoiceMarkers',
      ]),
      ...mapGetters([
        'logisticProviderLogo',
        'deliveryMethods',
        'deliveryMethodsNames',
        'tabResume',
      ]),
      title() {
        if (!this.invoice) return null;

        const {
          reconciliation_invoice_number,
          invoice_state_description,
        } = this.invoice;

        const title = [
          'Fatura',
          reconciliation_invoice_number,
          invoice_state_description,
        ].filter(item => !!item);

        return title.join(' - ');
      },
    },
    methods: {
      ...mapActions([
        'getInvoice',
        'getInvoiceMarkers',
        'downloadInvoiceFilePerUrl',
        'generateAnalyzeFile',
        'linkMarker',
        'unlinkMarker',
      ]),
    },
    created() {
      const { id } = this.$route.params;

      this.getInvoice(id)
        .then(() => this.getInvoiceMarkers(id))
        .catch(() => {
          this.$router.push({ name: 'invoice-audit-list' });
        });
    },
    components: {
      ScPageBase,
      ScField,
      ScTabs,
      ScTabItem,
      ScReconMarkersInput,
      TabInvoiceAuditDetailResume,
      TabInvoiceAuditDetailHistory,
      TabInvoiceAuditDetailOrderItems,
    },
  };
</script>

<style lang="scss" scoped>
  .invoice-audit-detail{
    align-items: normal;
  }

  .invoice-audit-detail__item{
    margin: 0 .5rem;
    &:last-child{
      margin-right: 0;
    }
    &:first-child{
      margin-left: 0;
    }
  }

  .invoice-audit-detail__logistic-provider{
    height: 70px;
  }
</style>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/PageInvoiceAuditDetail.vue